var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7998 5.48771C15.3649 2.77992 13.22 0.63505 10.5122 0.200147C9.69428 0.0687841 8.85541 0 7.99998 0C7.14455 0 6.30568 0.0687622 5.48773 0.200147C2.77994 0.63505 0.635047 2.77992 0.200143 5.48771C0.0687807 6.30564 0 7.14451 0 7.99998C0 8.85545 0.0687589 9.69432 0.200143 10.5123C0.635047 13.22 2.77996 15.3649 5.48773 15.7998C6.30568 15.9312 7.14455 16 7.99998 16C8.85541 16 9.69428 15.9312 10.5122 15.7998C13.22 15.3649 15.3649 13.22 15.7998 10.5123C15.9312 9.69432 16 8.85545 16 7.99998C16 7.14451 15.9312 6.30564 15.7998 5.48771Z",
    fill: "#0B5CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13H4.65068C4.08242 13 3.5747 12.6607 3.35724 12.1357C3.13978 11.6107 3.25892 11.0118 3.66076 10.6101L9.27084 5H5.24998C4.1454 5 3.24998 4.10458 3.24998 3H10.7193C11.2875 3 11.7952 3.33916 12.0127 3.86416C12.2302 4.38916 12.1111 4.98798 11.7094 5.38994L6.09926 11H10.75C11.8546 11 12.75 11.8954 12.75 13H12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIconAvatar);
export default __webpack_public_path__ + "static/media/zoom-icon-avatar.49d28b429c9c3b05eb3bccc89eac6390.svg";
export { ForwardRef as ReactComponent };